import React, { useContext } from "react"
import { withPrefix } from "gatsby"
import { getSourceFromChannel } from "./services/helperFunctions"
import { JourneyContext } from "./context/journeyContext"
const journeyss = require("../../static/journeyssr.json")


const Header = () => {
  const [journeyState, setJourneyState] = useContext(JourneyContext);
  return (
    <>
      {/* <!--Iselect Header Start--> */}
      <div className="header-fix-design">
        <div className="top-header-bg">
          <div className="container">
            <div  style={{
              display: "flex",
              justifyContent:"center",
              alignItems:"center"
            }} >
              <p>
                {" "}
                <span style={{ paddingBottom:"2px" }} className="fa fa-phone ph-icon"></span> Toll Free Number:
                {getSourceFromChannel(journeyState.channel) === "U" ?  "1800-258-5899" : "1800-891-0003"}
              </p>
              {getSourceFromChannel(journeyState.channel) !== "U" ?
              <>
                <p> &nbsp; | &nbsp; </p>
                <p>
                  {" "}
                  NRI Helpline Number: +91 120 4929050
                </p>
              </>  : null
              }
            </div>
          </div>
        </div>
        <div className="iselect-header">
          <div className="container">
            <div className="left-logo">
              {" "}
              <img src={withPrefix("/images/new/logo.png")} />
            </div>
            <div className="right-logo">
              {" "}
              <img
                 src={withPrefix(
                   `/images/${journeyss.data.products[0].journeys[0].journeyId}.jpeg`
                 )}
               />
            </div>
          </div>
        </div>
      </div>
      {/* <!--Iselect Header End--> */}
      <div className="header-space-design"></div>
    </>
  )
}

export default Header
